// extracted by mini-css-extract-plugin
module.exports = {"rootDiv":"gradientTitle_rootDiv__xzO4Z","text":"gradientTitle_text__YDUNq"};